// src/components/layout/MusicUploadSection.js - music card of a choreography.
// Thin wrapper around the shared MediaUploadCard (audit FL-39).
import React from 'react';
import MediaUploadCard from '../leader/MediaUploadCard';

const MusicUploadSection = ({ choreographyId, musicFile, onMusicUploaded, editable = true, lockedReason }) => (
  <MediaUploadCard
    kind="music"
    choreographyId={choreographyId}
    file={musicFile}
    editable={editable}
    lockedReason={lockedReason}
    onUploaded={onMusicUploaded}
  />
);

export default MusicUploadSection;
